import React from 'react';

/**
 * Stacked persistent banners shown at the top of an order detail page.
 *
 * - Renders one banner per entry in `notifications` (both club-scoped and
 *   order-scoped).
 * - No dismiss button. Removal happens via the Notifications button on the
 *   order page (order-scoped) or via Settings → Notifications.
 * - Inline block layout (not fixed) so the page content slides down beneath.
 */
export default function OrderNotificationsBanner({ notifications }) {
    const list = Array.isArray(notifications) ? notifications : [];
    if (list.length === 0) return null;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
            {list.map((n, i) => {
                const isOrder = n.scope === 'order' || !!n.order_name;
                const headerText = isOrder
                    ? `Order ${n.order_name || ''}`
                    : (n.team_name
                        ? `${n.club_name || ''} · ${n.team_name}`
                        : (n.club_name || ''));
                return (
                    <div
                        key={n.id ?? i}
                        role="status"
                        style={{
                            background: '#fde8e8',
                            border: '1px solid #f5a5a5',
                            borderLeft: '6px solid #e57373',
                            borderRadius: 8,
                            padding: '10px 14px',
                            display: 'flex',
                            gap: 12,
                            alignItems: 'flex-start',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                            color: '#5b1212',
                        }}
                    >
                        <span style={{ fontSize: 18, lineHeight: '20px' }} aria-hidden="true">⚡</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', opacity: 0.75 }}>
                                Notification — {headerText}
                            </div>
                            <div style={{ fontSize: 14, marginTop: 2, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {n.message}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
